/**
 * @file
 * VUE Filters
 * Used in library: vue
 *
 * Use this file to register filters
 * See https://vuejs.org/v2/guide/filters.html
 * This configuration will be set in @/bootstrap/app.ts
 */

import {FilterOptions} from 'simpli-web-sdk'

/**
 * VUE Filters
 */
export const filters: FilterOptions = {}
